import {
    SnackBarPopupState,
    ToggleSnackBarPopupVisibilityAction
} from "./type";

export function toggleSnackBarPopupVisibilityHandler(
    state: SnackBarPopupState,
    action: ToggleSnackBarPopupVisibilityAction
): SnackBarPopupState {
    return Object.assign({}, state, { isVisible: action.payload.show });
}



// WEBPACK FOOTER //
// ./src/store/SnackBarPopup/handlers.ts